import React from 'react'
import {Icon} from '@salesforce/retail-react-app/app/components/shared/ui'

const ChefIcon = (props) => {
    return (
        <Icon viewBox="0 0 25 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.999023 7.21976C0.999023 9.81215 2.7188 12.0365 5.12097 12.7512L5.12102 23.9998H20.044V12.7511C22.4455 12.0363 24.165 9.81191 24.165 7.21976C24.165 4.0321 21.5809 1.44876 18.394 1.44876C17.6356 1.44876 16.8985 1.59553 16.215 1.87426C15.3961 0.722872 14.0572 -0.000244141 12.582 -0.000244141C11.1074 -0.000244141 9.7682 0.723034 8.94965 1.87421C8.26614 1.59557 7.5289 1.44876 6.77102 1.44876C3.5833 1.44876 0.999023 4.03191 0.999023 7.21976ZM18.044 18.5177V11.0741L18.9086 10.956C20.7639 10.7024 22.165 9.11014 22.165 7.21976C22.165 5.1368 20.4765 3.44876 18.394 3.44876C17.6567 3.44876 16.9546 3.65915 16.3494 4.04987L15.3181 4.71573L14.8746 3.57105C14.5104 2.63131 13.6058 1.99976 12.582 1.99976C11.5588 1.99976 10.6537 2.63163 10.2907 3.57043L9.84765 4.71619L8.81561 4.04987C8.2108 3.65938 7.50771 3.44876 6.77102 3.44876C4.68767 3.44876 2.99902 5.13667 2.99902 7.21976C2.99902 9.11027 4.40027 10.7024 6.25636 10.956L7.12108 11.0741L7.12059 18.5177H18.044ZM7.12102 20.5177V21.9998H18.044V20.5177H7.12102Z"
                fill="black"
            />
        </Icon>
    )
}

export default ChefIcon
